// extracted by mini-css-extract-plugin
module.exports = {"canvas":"AbstractBackground_canvas__yOk7Q"};